<template>
	<div class="painter-income-container">
		<div class="incomeInfoBox">
			<div class="incomeInfo">
				<div class="title">可提现收入</div>
				<div class="balance"><span
						class="unit">¥</span>{{userInfo.balance ? (userInfo.balance * 1).toFixed(2) : '0'}}
				</div>
				<div class="incomeTypeBox">
					<div class="incomeType"><span class="typeTitle">总收入（累计）:</span><span
							class="unit">¥</span>{{userInfo.all_price ? (userInfo.all_price * 1).toFixed(2) : '0'}}
					</div>
					<div class="incomeType"><span class="typeTitle">冻结收入:</span><span
							class="unit">¥</span>{{userInfo.dj_price ? (userInfo.dj_price * 1).toFixed(2) : '0'}}</div>
				</div>
			</div>
			<div class="cashOut" @click="cashOutPrice">申请提现</div>
		</div>
		<div class="recordTitle">收入明细</div>
		<div class="recordList" v-if="recordDara.length">
			<div class="recordItem" v-for="(item,index) in recordDara" :key="index">
				<div class="recordType">
					{{item.content}}
					<div class="time">
						{{item.create_time}}
					</div>
				</div>
				<div class="price">{{item.price > 0 ? '+ ¥' + item.price : '¥' + item.price}}</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<el-dialog class="phoneDialog" :visible="phoneShow" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					申请提现
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="phoneRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="price">
						<div class="form-group" style="width: 3.85rem;">
							<div class="phone-input-container">
								<input type="tel" v-model="ruleForm.price" placeholder="请输入提现金额" class="phone-input" />
								<button type="button" @click="ruleForm.price = userInfo.balance ? userInfo.balance : ''"
									class="get-code-btn">全部提现</button>
							</div>
						</div>
					</el-form-item>
				</el-form>
				<div class="title">收款账户</div>
				<div class="infoItem">
					<div class="infoTitle">真实姓名：{{userInfo.sk_name ? userInfo.sk_name : ''}}</div>
				</div>
				<div class="infoItem">
					<div class="infoTitle">银行卡号：{{userInfo.sk_num ? userInfo.sk_num : ''}}</div>
				</div>
				<div class="infoItem">
					<div class="infoTitle">开户行：{{userInfo.sk_bank ? userInfo.sk_bank : ''}}</div>
				</div>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitPhoneForm('phoneRuleForm')">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'您本次提现申请已成功提交'" :descTwo="'请耐心等待平台审核！'"
			@clickOk="sucPop = false;" v-if="sucPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="errorDesc" :descTwo="errorDescTwo"
			@clickOk="$router.push('/user-info')" v-if="tipPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="errorDesc" :descTwo="errorDescTwo"
			@clickOk="errPop = false" v-if="errPop" />
	</div>
</template>

<script>
	import PopToast from '../../components/PopToast.vue'
	export default {
		components: {
			PopToast,
		},
		data() {
			return {
				recordDara: [],
				errPop: false,
				errorDesc: '',
				errorDescTwo: '',
				tipPop: false,
				sucPop: false,
				userInfo: {},
				phoneShow: false,
				ruleForm: {
					price: '',
				},
				rules: {
					price: [{
						required: true,
						message: '请输入提现金额',
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.userDetails()
			this.balanceMoney_List()
		},
		methods: {
			balanceMoney_List() {
				this.$api.post('/UserD/balance_money_list', {}).then(result => {
					if (result.code == 1) {
						this.recordDara = result.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(result => {
					if (result.code == 1) {
						this.userInfo = result.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			cashOutPrice() {
				if (!this.userInfo.sk_name || !this.userInfo.sk_name || !this.userInfo.sk_name) {
					this.errorDesc = '暂没收款信息'
					this.errorDescTwo = '请到个人信息页面提交'
					this.tipPop = true
				} else {
					this.phoneShow = true
				}
			},
			submitPhoneForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/hs_withdraw', {
							...this.ruleForm,
						}).then(res => {
							this.phoneShow = false
							if (res.code == 1) {
								this.sucPop = true
								this.userDetails()
								this.balanceMoney_List()
								this.handleClose()
							} else {
								if (res.msg == '余额不足') {
									this.errorDesc = res.msg
									this.errorDescTwo = ''
									this.errPop = true
								}
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						console.log(res)
					}
				}).catch(err => {
					console.log(err);
				})
				this.$api.post('/Hua/fensi', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						console.log(res)
					}
				}).catch(err => {
					console.log(err);
				})
				this.$api.post('/Hua/xinxi_save', {
					sk_name: '',
					sk_bank: '',
					sk_num: '',
				}).then(res => {
					if (res.code == 1) {
						console.log(res)
					}
				}).catch(err => {
					console.log(err);
				})
				this.$api.post('/UserD/user_details', {}).then(result => {
					if (result.code == 1) {
						console.log(result)
					} else {
						console.log(result.msg)
					}
				}).catch(err => {
					console.log(err);
				})

			},
			handleClose() {
				this.ruleForm.price = ''
				this.phoneShow = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.painter-income-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: .24rem .4rem;
	}

	.incomeInfoBox {
		width: 100%;
		height: 1.74rem;
		background: rgba(250, 239, 221, .5);
		border-radius: .04rem;
		padding: .32rem .4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.incomeInfo {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.title {
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .22rem;
			}

			.balance {
				display: flex;
				align-items: baseline;
				font-weight: 500;
				font-size: .4rem;
				color: #000000;

				.unit {
					font-size: .24rem;
				}
			}

			.incomeTypeBox {
				display: flex;
				align-items: center;

				.incomeType {
					margin-right: .32rem;
					display: flex;
					align-items: center;
					font-weight: 700;
					font-size: .16rem;
					color: #252525;
					line-height: .22rem;

					.typeTitle {
						font-size: .14rem;
						color: #252525;
					}
				}
			}
		}

		.cashOut {
			width: .9rem;
			height: .36rem;
			background: #E29358;
			border-radius: .04rem;
			font-weight: 500;
			font-size: .12rem;
			color: #252525;
			line-height: .36rem;
			text-align: center;
			cursor: pointer;
		}
	}

	.recordTitle {
		margin-top: .16rem;
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
	}

	.recordList {
		display: flex;
		flex-direction: column;
		overflow-y: auto;

		.recordItem {
			height: .7rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: .12rem 0;
			border-bottom: .01rem solid #CCCCCC;

			.recordType {

				display: flex;
				flex-direction: column;
				font-weight: 400;
				font-size: .16rem;
				color: #161616;

				.time {
					font-weight: 400;
					font-size: .12rem;
					color: #73767C;
				}
			}
		}

		.price {
			font-weight: 500;
			font-size: .16rem;
			color: #E29358;
		}
	}


	.phoneDialog {
		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.form-group {
					// margin-top: .16rem;
				}

				// 手机号和验证码输入框样式
				.phone-input-container {
					width: 100%;
					height: 0.44rem;
					border: .01rem solid #EFD8B8;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.phone-input {
					height: 0.4rem;
					width: 1.8rem;
					border: none;
					outline: none;
					padding: 0 0;

					font-size: 0.14rem;
					color: #333333;

					&::placeholder {
						color: #999999;
					}
				}

				.get-code-btn {
					padding: 0 0;
					color: #E29358;
					font-size: 0.14rem;
					cursor: pointer;
					border: none;

					&:disabled {
						background: #FFFFFF;
						color: #CCCCCC;
						border-color: #CCCCCC;
						cursor: not-allowed;
					}
				}

				.title {
					margin-top: .08rem;
					font-weight: 600;
					font-size: .14rem;
					color: #999999;
					line-height: .2rem;
				}

				.infoItem {
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: .14rem;
					color: #333333;
					line-height: .24rem;

					.infoTitle {
						font-size: .14rem;
						color: #333333;
					}
				}

				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .16rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>